import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * clsx와 tailwind-merge를 조합한 유틸리티 함수
 * 조건부 클래스명 처리와 중복 Tailwind CSS 클래스 병합을 동시에 처리합니다.
 * 
 * @param inputs - 클래스명 값들 (문자열, 객체, 배열 등)
 * @returns 병합된 클래스명 문자열
 * 
 * @example
 * ```tsx
 * // 기본 사용법
 * cn('px-2 py-1', 'bg-red-500');
 * // 결과: 'px-2 py-1 bg-red-500'
 * 
 * // 조건부 클래스명
 * cn('text-base', {
 *   'text-red-500': isError,
 *   'text-green-500': isSuccess
 * });
 * 
 * // 중복 클래스 병합
 * cn('px-2 py-1', 'px-4 py-2');
 * // 결과: 'px-4 py-2' (나중에 오는 값이 우선)
 * 
 * // 복합 사용
 * cn(
 *   'text-sm font-medium',
 *   variant === 'primary' && 'bg-blue-500 text-white',
 *   variant === 'secondary' && 'bg-gray-200 text-gray-900',
 *   size === 'lg' && 'px-6 py-3 text-base',
 *   className
 * );
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}